import React from 'react';

const GroupingSelector = React.memo(({ presets, activePreset, onSelect }) => {
  return (
    <div style={{ marginBottom: '16px' }}>
      <h3 style={{ margin: '0 0 8px 0' }}>Grouping</h3>
      <select
        value={activePreset || ''}
        onChange={(e) => onSelect(e.target.value || null)}
        style={{
          padding: '8px 10px',
          borderRadius: '4px',
          border: '1px solid #ccc',
          fontSize: '14px',
          minWidth: '260px',
          backgroundColor: 'white',
          cursor: 'pointer',
        }}
      >
        {presets.map((preset) => (
          <option key={preset.id} value={preset.id}>
            {preset.label}
          </option>
        ))}
        <option value="">Custom (manual selection)</option>
      </select>
    </div>
  );
});

export default GroupingSelector;
